/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Modal, Table, } from 'semantic-ui-react';
import Axios from 'axios';
import moment from 'moment';

import APP_CONSTANTS from '../../config/constants';


const BillPaymentDetailsModal = ({ handleCloseEdit, billData, ...props }) => {

    const [billPaymentsData, setBillPaymentsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('apiToken')
        const customer_no = localStorage.getItem('customerNo')
        const user_id = localStorage.getItem('userId')
        const billReferenceNo = billData.refNo
        Axios.get(`${APP_CONSTANTS.BASE_URL}sales/sales-receivables/getInvoiceReceipt?customer_no=${customer_no}&user_id=${user_id}&billReferenceNo=${billReferenceNo}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setBillPaymentsData(response.data.data)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])

    return (
        <>
            <Modal.Content>
                <Table size="large" className="w3-medium">
                    {billPaymentsData != null ?
                        <>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="w3-white" colSpan="8">Bills Payment Details</Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell className="labelName p-bold-600">Payment Date</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Payment Reference No.</Table.HeaderCell>
                                    <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {billPaymentsData && billPaymentsData.map((object, index) => {
                                    return (
                                        <Table.Row verticalAlign='middle' key={index}>
                                            <React.Fragment>
                                                <Table.Cell>{moment(object.payment_date).format('DD-MM-YYYY')}</Table.Cell>
                                                <Table.Cell>{object.reference_number}</Table.Cell>
                                                <Table.Cell>{object.amount}</Table.Cell>
                                            </React.Fragment>
                                        </Table.Row>
                                    )
                                })}
                            </Table.Body>
                        </>
                        : <div className='text-center'>{'No Data Found'}</div>
                    }

                </Table>
            </Modal.Content>
        </>
    )
}


export default BillPaymentDetailsModal
